import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Estimate from './pages/Estimate';
import PaintVision from './pages/PaintVision';
import ThankYou from './pages/ThankYou';
import { ChatWidgetController } from './components/ChatWidgetController';
import { FloatingCallButton } from './components/FloatingCallButton';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ChatWidgetController />
                <FloatingCallButton />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/estimate" element={<Estimate />} />
                    <Route path="/paintvision" element={<PaintVision />} />
                    <Route path="/estimate/thank-you" element={<ThankYou />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
